import { BaseSelect } from '@app/components';
import { taxApi } from '@app/store/services/tax';
import { createColumnHelper } from '@tanstack/react-table';
import { ITax } from '@app/common';
import React from 'react';
import { ResourceSelect, ResourceSelectParentProps } from '../ResourceSelect';

const columnHelper = createColumnHelper<ITax>();

export const TaxSelect = ({ label = 'Taxes', ...props }: ResourceSelectParentProps<ITax>) => {
  const columns = [
    columnHelper.accessor('name', {
      header: () => (
        <BaseSelect.ListHeaderItem width="100%">
          Nom
        </BaseSelect.ListHeaderItem>
      ),
      cell: (info) => (
        <BaseSelect.ListItemCol width="100%">
          <BaseSelect.ListItemText numberOfLines={1} bold>
            {info.getValue()}
          </BaseSelect.ListItemText>
        </BaseSelect.ListItemCol>
      ),
    }),
  ];

  return (
    <ResourceSelect
      label={label}
      columns={columns}
      useQuery={taxApi.useReadManyTaxQuery}
      {...props} />
  );
};
